import React from "react";
import HeroSection from "../components/HeroSection"; // Import HeroSection

export default function OurServicePage() {
  return (
    <section id="our-service" className="our-service-section section">
      <div className="container">
        <h2 className="section-title">Our Services</h2>
        <p className="section-description">
          Solusi Terintegrasi untuk Kebutuhan IT, Audio Visual, & Automation. Kami menawarkan berbagai layanan untuk memenuhi kebutuhan teknologi, di antaranya:
        </p>
        <ul className="service-list">
          <li>
            <strong>Desain dan Implementasi Sistem IT, Audio Visual, & Automation:</strong> Menyediakan solusi untuk ruang konferensi, ruang rapat, ruang kelas, auditorium, Ballroom, command center, dan lain-lain.
          </li>
          <li>
            <strong>Desain 3 Dimensi Interior:</strong> Menyediakan visualisasi ruang yang memungkinkan klien melihat implementasi perangkat secara nyata dalam desain.
          </li>
          <li>
            <strong>Integrasi Sistem IT, Audio Visual, & Automation:</strong> Menghubungkan berbagai perangkat untuk menciptakan sistem yang berkolaborasi dan mudah digunakan.
          </li>
          <li>
            <strong>Dukungan dan Pemeliharaan:</strong> Memberikan layanan purna jual berupa dukungan teknis dan pemeliharaan sistem untuk memastikan perangkat selalu berfungsi optimal.
          </li>
        </ul>
      </div>
    </section>
  );
}